module.exports = __webpack_public_path__ + "img/logo.a6906b71.jpg";